if (typeof window.BreadcrumbComponentClass === 'undefined') {
    class BreadcrumbComponent extends HTMLElement {
        connectedCallback() {
            if (!this.isConnected) return;
            this.classList.add('initialized');
            this._firstLink = this.querySelector('.link.home-link');
            this._lastLink = this.querySelector('.breadcrumb-sentinel');
            this._initObservers();
            this._initCollectionTracking();
            this._restoreCollection();
        }

        disconnectedCallback() {
            if (this._scrollToFirstObserver) this._scrollToFirstObserver.disconnect();
            if (this._scrollToLastObserver) this._scrollToLastObserver.disconnect();
            if (this._clickHandler) document.removeEventListener('click', this._clickHandler);
        }

        static _createVisibilityHandler(position, breadcrumb) {
            return (entries, observer) => {
                for (const entry of entries) {
                    if (!breadcrumb.isConnected) {
                        observer.disconnect();
                        return;
                    }
                    breadcrumb.classList.toggle(`disable-${position}`, entry.isIntersecting);
                }
            };
        }

        _initObservers() {
            if (!this._firstLink || !this._lastLink) return;

            this._scrollToFirstObserver = new IntersectionObserver(
                BreadcrumbComponent._createVisibilityHandler('first', this),
                { threshold: 1 }
            );
            this._scrollToLastObserver = new IntersectionObserver(
                BreadcrumbComponent._createVisibilityHandler('last', this),
                { threshold: 0.6 }
            );

            this._scrollToFirstObserver.observe(this._firstLink);
            this._scrollToLastObserver.observe(this._lastLink);
        }

        _initCollectionTracking() {
            if (!document.body.matches('.template-collection')) return;
            this._saveCollection(true);
            this._bindCollectionClickTracker();
        }

        _saveCollection(showCollection) {
            const title = this.dataset.collectionTitle || this.dataset.labelProducts || 'Products';
            const data = { name: title, url: window.location.pathname, show: showCollection };
            try {
                localStorage.setItem('_breadcrumb_collection', JSON.stringify(data));
            } catch (_) { }
        }

        _bindCollectionClickTracker() {
            if (this._clickHandler) return;
            this._clickHandler = (event) => {
                const target = event.target;
                if (!target.matches('.card-link')) return;
                const inProductGrid = target.closest('.shopify-section[id*="product-grid"]') !== null;
                this._saveCollection(inProductGrid);
            };
            document.addEventListener('click', this._clickHandler);
        }

        _restoreCollection() {
            if (!document.body.matches('.template-product')) return;

            const link = this.querySelector('.breadcrumb-collection');
            if (!link) return;

            let stored = null;
            try {
                const raw = localStorage.getItem('_breadcrumb_collection');
                stored = raw ? JSON.parse(raw) : null;
            } catch (_) { }

            const referrerUrl = this._safeParseUrl(document.referrer);
            const isValidReferral = stored
                && referrerUrl
                && referrerUrl.pathname.includes('/collections/')
                && referrerUrl.pathname === stored.url
                && stored.show;

            if (!isValidReferral) return;

            link.href = stored.url;
            link.textContent = stored.name;
        }

        _safeParseUrl(url) {
            try {
                return new URL(url);
            } catch (_) {
                return null;
            }
        }
    }

    window.BreadcrumbComponentClass = BreadcrumbComponent;

    const defineElement = () => {
        if (!customElements.get('breadcrumb-component')) {
            customElements.define('breadcrumb-component', BreadcrumbComponent);
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', defineElement);
    } else {
        defineElement();
    }
}
